import React, { useContext, useState, useEffect, forwardRef } from "react";
import { Redirect } from "react-router-dom";
import MaterialTable from "material-table";
import {
  AddBox,
  ArrowDownward,
  Check,
  ChevronLeft,
  ChevronRight,
  Clear,
  DeleteOutline,
  Edit,
  FirstPage,
  LastPage,
  FilterList,
  Remove,
  SaveAlt,
  Search,
  ViewColumn,
} from "@material-ui/icons";

// Contexts
import OrderContext from "../../../../context/orders/v1/OrdersContext";
import PatchedPagination from "../../../layout/MTPagination";

// Material UI Styling
const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

const OrderSearchResult = () => {
  const { searchResult } = useContext(OrderContext);

  const [rows, setRows] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [redirectToEdit, setRedirectToEdit] = useState(false);

  const column = [
    {
      field: "name",
      title: "Order",
      editable: "never",
      cellStyle: {
        width: 20,
        minWidth: 20,
        fontSize: 13,
      },
    },
    {
      field: "store_name",
      title: "Storename",
      editable: "never",
      cellStyle: {
        width: 20,
        minWidth: 20,
        fontSize: 13,
      },
    },
    {
      field: "created_at",
      title: "Date",
      render: (rowData) => {
        const date = new Date(rowData.created_at);

        const newDate = new Intl.DateTimeFormat("en", {
          month: "short",
          day: "numeric",
          hour12: true,
          hour: "numeric",
          minute: "2-digit",
          // timeStyle: "short",
          // dateStyle: "medium",
        }).format(date);

        return newDate;
      },
      editable: "never",
      cellStyle: {
        width: 50,
        minWidth: 50,
        fontSize: 13,
      },
    },
    {
      field: "customer.default_address.name",
      title: "Customer",
      editable: "never",
      cellStyle: {
        width: 50,
        minWidth: 50,
        fontSize: 13,
      },
    },
    {
      field: "total_price",
      title: "Total",
      editable: "never",
      cellStyle: {
        width: 20,
        minWidth: 20,
        fontSize: 13,
      },
    },
    {
      field: "financial_status",
      title: "Payment",
      render: (rowData) => {
        if (rowData.financial_status) {
          const status = rowData.financial_status.replace("_", " ");
          return String(status.charAt(0).toUpperCase() + status.slice(1));
        }
      },
      editable: "never",
      cellStyle: {
        width: 20,
        minWidth: 20,
        fontSize: 13,
      },
    },
    {
      field: "fulfillment_status",
      title: "Fulfillment",
      render: (rowData) => {
        if (rowData.fulfillment_status) {
          const status = rowData.fulfillment_status;
          return String(status.charAt(0).toUpperCase() + status.slice(1));
        } else {
          return "Unfulfilled";
        }
      },
      editable: "never",
      cellStyle: {
        width: 20,
        minWidth: 20,
        fontSize: 13,
      },
    },
    {
      field: "transaction_id",
      title: "Transaction ID",
      render: (rowData) =>
        rowData.transaction_id
          .filter((each) => {
            return each !== null;
          })
          .join()
          .replace(",", ", "),
      editable: "never",
      cellStyle: {
        width: 50,
        minWidth: 50,
        fontSize: 13,
      },
    },
  ];

  const rowEvents = (e, rowData) => {
    setSelectedRowData(rowData);
    setRedirectToEdit(true);
  };

  useEffect(() => {
    if (searchResult) {
      setRows(searchResult);
    }
  }, [searchResult]);

  return redirectToEdit && selectedRowData ? (
    <Redirect
      to={{
        pathname: "/order/edit",
        state: {
          order: selectedRowData,
        },
      }}
    />
  ) : (
    <MaterialTable
      data={rows}
      columns={column}
      icons={tableIcons}
      onRowClick={(e, rowData) => rowEvents(e, rowData)}
      // localization={{
      //   header: {
      //     actions: "Actions",
      //   },
      //   body: {
      //     editTooltip: "Edit Status",
      //     editRow: {
      //       saveTooltip: "Save",
      //     },
      //   },
      // }}
      options={{
        search: false,
        toolbar: false,
        sorting: true,
        // actionsColumnIndex: -1,
        pageSizeOptions: [5, 10, 25, 50],
        pageSize: rows.length > 3 ? 10 : 5,
        padding: "dense",
        headerStyle: {
          fontWeight: "bold",
          fontSize: 13,
          zIndex: 8,
        },
        showEmptyDataSourceMessage: true,
      }}
      components={{
        Pagination: PatchedPagination,
      }}
    />
  );
};

export default OrderSearchResult;
